import { Alert, Stack } from "@mui/material";
import useEmbedded from "../../../hooks/useEmbedded";
import CustomerRelatedFields from "./CustomerRelatedFields";

type Step1Props = {
  showPassword: boolean;
  setShowPassword: (flag: boolean) => void;
  errors: any;
  localStorageAccessible: boolean;
};

export default function Step1({ showPassword, setShowPassword, errors, localStorageAccessible }: Step1Props) {
    const { isEmbedded } = useEmbedded();

    return (
    <Stack spacing={2}>
      {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

      <CustomerRelatedFields 
        includePasswordField={(!isEmbedded || localStorageAccessible)}
        includeBusinessNameField={true}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        disableEmailField={false}
      />
    </Stack>
  );
}
